import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Customers from "./views/Customers";
import Users from "./views/Users";
import Sites from "./views/Sites";
import Devices from "./views/Devices";
import SteeringPreferences from "./views/SteeringPreferences";
import MarketContexts from "./views/MarketContexts";
import ElectricalSystems from "./views/ElectricalSystems";
import CustomerDetails from "./views/CustomerDetails";
import RedirectToCustomerDetails from "./views/RedirectToCustomerDetails";
import Pricing from "./views/Pricing";
import EdgeVersions from "./views/EdgeVersions";
import Profile from "./views/Profile";
import StreamSwagger from "./views/StreamDocs";

import { useAuth0 } from "@auth0/auth0-react";
import { AuthInitializer } from "./AuthInitializer";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isLoading, error } = useAuth0();
  document.title = process.env.REACT_APP_TITLE || 'ReVolta Admin';

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <AuthInitializer>
      <Router history={history}>
        <div id="app" className="d-flex flex-column h-100">
          <NavBar />
          <div className="flex-grow-1 m-5">
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/customers" component={Customers} />
              <Route path="/users" component={Users} />
              <Route path="/sites" component={Sites} />
              <Route path="/devices" component={Devices} />
              <Route path="/steeringPreferences" component={SteeringPreferences} />
              <Route path="/marketContexts" component={MarketContexts} />
              <Route path="/electricalSystems" component={ElectricalSystems} />
              <Route path="/pricing" component={Pricing} />
              <Route path="/edge" component={EdgeVersions} />
              <Route path="/customerDetails/:customerId" component={CustomerDetails} />
              <Route path="/redirectToCustomerDetails/:siteId" component={RedirectToCustomerDetails} />
              <Route path="/profile" component={Profile} />
              <Route path="/docs/rv-stream" component={StreamSwagger} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthInitializer>
  );
};

export default App;
